( function() {
	'use strict';

	document.addEventListener( 'DOMContentLoaded', function() {

		const urlParams = new URLSearchParams( window.location.search );
		const preselectState = ( urlParams && urlParams.get( 'state' ) ) ?? '';

		document.querySelectorAll( '.state-selector-container' ).forEach( ( container ) => {

			if ( preselectState ) {
				const selectedItem = container.querySelector( '.dropdown-item[data-state-code="' + preselectState + '"]' );
				if ( selectedItem ) {
					const siblings = selectedItem.parentElement ? selectedItem.parentElement.children : [];
					Array.from( siblings ).forEach( ( el ) => el.classList.remove( 'active' ) );
					selectedItem.classList.add( 'active' );
					const dropdownToggle = container.querySelector( '.dropdown-toggle' );
					if ( dropdownToggle ) {
						dropdownToggle.textContent = selectedItem.textContent;
					}
					// $( '.filter-list' ).eq( 0 ).trigger( 'filter-change', [{
					// 	key: 'state',
					// 	val: preselectState
					// }] );
				}
			}

			container.addEventListener( 'click', ( e ) => {
				const target = e.target;
				if ( !( target instanceof Element ) ) {
					return;
				}
				const item = target.closest( '.dropdown-item:not(.disabled)' );
				if ( item && container.contains( item ) ) {
					const ctrl = item.closest( '.dropdown' );

					const siblings = item.parentElement ? item.parentElement.children : [];
					Array.from( siblings ).forEach( ( el ) => el.classList.remove( 'active' ) );
					item.classList.add( 'active' );

					if ( ctrl ) {
						const toggle = ctrl.querySelector( '.dropdown-toggle' );
						if ( toggle ) {
							toggle.textContent = item.textContent;
						}
					}

					/**
					 * note, this acts only on the first .filter-list that is found
					 */
					// $( '.filter-list' ).eq( 0 ).trigger( 'filter-change', [{
					// 	key: 'state',
					// 	val: $item.data( 'state-code' )
					// }] )

					return;
				}

				const btn = target.closest( '.view-courses:not(.disabled)' );
				if ( !btn || !container.contains( btn ) ) {
					return;
				}
				const siblingDropdown = btn.parentElement
					? btn.parentElement.querySelector( '.dropdown' )
					: null;
				const activeItem = siblingDropdown
					? siblingDropdown.querySelector( '.dropdown-item.active' )
					: null;
				const activeState = activeItem instanceof HTMLElement
					? activeItem.dataset.stateCode
					: undefined;

				if ( btn instanceof HTMLElement && btn.dataset.requestedState === activeState ) {
					return;
				}

				const baseUrl = btn instanceof HTMLElement ? btn.dataset.baseUrl : '';
				if ( !baseUrl || !activeState ) {
					return;
				}

				window.location.assign( baseUrl + ( baseUrl.indexOf( '?' ) > -1 ? '&' : '?' ) + 'state=' + activeState );
			} );

		} );

	} );
} )();
